export const getWeeks = (firebase, uid, setWeeks) => {
    firebase.getMenus(uid).get()
      .then(querySnapshot => {
        querySnapshot.docs.forEach(doc => {
          setWeeks(Weeks => [...Weeks, doc.id]);
        });
      })
      .catch((error) => {
        console.error('Erreur lors de la récupération des semaines:', error);
      });
};